import { Directive, Injector, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { NgControl } from '@angular/forms';
import { AppTextService } from '@fi-shared/app-text';

const DEFAULT_ERROR_MESSAGES_MAP = {
    required: 'common_error.mandatory',
    email: 'error_message.email_invalid',
    pattern: 'error_message.pattern_invalid',
};

@Directive()
export class FiErrorMessageBase implements OnInit, OnDestroy {
    @Input() fiErrorCustomMessages: { [prop: string]: string };

    protected appTextService: AppTextService;
    constructor(injector: Injector) {
        this.appTextService = injector.get(AppTextService);
    }

    private errorMessagesMap: { [prop: string]: string };

    ngOnInit(): void {
        this.errorMessagesMap = Object.assign({}, DEFAULT_ERROR_MESSAGES_MAP);
        if (this.fiErrorCustomMessages) {
            this.errorMessagesMap = Object.assign(this.errorMessagesMap, this.fiErrorCustomMessages);
        }
    }

    protected getErrorMessage(ngModel: NgControl): string {
        const errorMessages: string[] = [];
        if (ngModel.invalid) {
            for (let errorProp in ngModel.errors) {
                let errorMessageTextId = this.errorMessagesMap[errorProp];
                if (errorMessageTextId) {
                    const errorMessage = this.appTextService.get(errorMessageTextId);
                    if (errorMessages.indexOf(errorMessage) === -1) {
                        errorMessages.push(errorMessage);
                    }
                } else if (errorMessageTextId !== null && errorMessageTextId !== '') {
                    errorMessages.push(errorProp);
                }
            }
        }
        return errorMessages.join(', ');
    }

    protected ngOnDestroy$ = new Subject<void>();
    ngOnDestroy(): void {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }
}
